import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplicationProcessApi from 'api/curo/ApplicationProcessApi';
import { ApplicationProcessActionTypes } from 'enums/curo/ApplicationProcessActionTypes';

export const createOrganicCreditAndAutoOriginationCheckThunk = (api: ApplicationProcessApi) =>
  createAsyncThunk(ApplicationProcessActionTypes.OrganicCreditAndAutoOriginationCheck, async () => {
    const response = await api.organicCreditAndAutoOriginationCheck();
    return response;
  });
